import React from 'react'

type HTMLContentDisplayProps = {
  rawContent: string
}

export const HTMLContentDisplay = ({ rawContent }: HTMLContentDisplayProps): React.ReactElement => {
  return <div className="article-html-embed" dangerouslySetInnerHTML={{ __html: rawContent }}></div>
}
